import React from "react";
import { FormattedMessage } from "react-intl";
import { Col, FormGroup, FormLabel } from "react-bootstrap";
import { Controller, UseFormReturn } from "react-hook-form";
import { messages } from "../../EditExtra/messages";
import { FormType } from "../../EditExtra/types";
import { InputMultiCheckbox } from "../InputMultiCheckbox";
import { useLocaleProvider } from "../../../../components/locale-provider";
import { applyToGuestOptions } from "../../EditExtra/defaultData";
import { ErrorFieldMessage } from "../ErrorFieldMessage";

type RateApplyToGuestsInputProps = UseFormReturn<FormType> & { disabled: boolean; };

export function RateApplyToGuestsInput({ control, disabled, formState }: RateApplyToGuestsInputProps) {
  const locale = useLocaleProvider();
  const shortLocale = locale?.currentLocale?.substring(0, 2);

  const getDisplayMultiCheckbox = (locale: string) => (option: {
    translations: { [key: string]: { name: string; description: string } };
  }) => option.translations[locale]?.name;

  return <FormGroup as={Col}>
    <FormLabel column sm={12}>
      <FormattedMessage {...messages.applyTo} /> {"*"}
    </FormLabel>
    <Col sm={3}>
      <Controller
        name="applyToGuests"
        rules={{ required: true }}
        control={control}
        render={({ field }) => (
          <InputMultiCheckbox
            getDisplay={getDisplayMultiCheckbox(shortLocale)}
            className="witadmin-bs3"
            disabled={disabled}
            field={{
              fieldName: "applyToGuestsMultiCheckbox",
              options: applyToGuestOptions,
              selectables: true
            }}
            {...field}
          />
        )}
      />
      {formState.errors.applyToGuests && (
        <ErrorFieldMessage {...messages.presenceValidator} />
      )}
    </Col>
  </FormGroup>;
}